<template>
  <RouterLink :to="target">
    <div class="w-43 h-76 rounded-xl border border-[#7CADB9] flex flex-col items-center justify-between p-6 shadow hover:bg-[#25B0D725] duration-500 hover:scale-105 active:scale-100">
      <!-- Circular Icon -->
      <div class="w-26 h-26 rounded-full border-6 flex items-center justify-center"
      :style="{ borderColor: borderColor }">
        <span class="text-2xl font-bold" :style="{ color: borderColor }">{{ percentage }}%</span>
      </div>

      <!-- Title -->
      <div class="text-center text-xl font-semibold text-[#3A5762]">
        <slot></slot>
      </div>

      <!-- Arrow Button -->
      <a class="w-full pt-10 flex gap-2 items-center justify-center border-[#7CADB9] border-t-2 cursor-pointer">
        <img class="duration-200 hover:scale-125 active:scale-100 p-4" src="@/assets/img/ArrowLeftStike.svg" alt="">
      </a>
    </div>
  </RouterLink>

</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    borderColor: {
      type: String,
      default: '#7CADB9'
    },
    percentage: {
      type: [String, Number],
      default: '0'
    },
    statusFilter: {
      type: String,
      default: ''
    },
    // El porcentaje resume solo las solicitudes propias (Back Office), así que
    // al pulsarlo el listado tiene que abrirse con ese mismo alcance (ADS-0113).
    mine: {
      type: Boolean,
      default: false
    }
})

const target = computed(() => ({
  path: '/request',
  query: {
    status: props.statusFilter,
    ...(props.mine ? { mine: '1' } : {})
  }
}))
</script>

